import type {ReactNode} from 'react';
import type {LucideIcon} from 'lucide-react';

export function EmptyTabState({
  icon: Icon,
  title,
  description,
  action,
}: {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: ReactNode;
}) {
  return (
    <section className='flex flex-col items-center rounded-lg border bg-white px-6 py-12 text-center'>
      <span className='mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 text-gray-500'>
        <Icon className='h-5 w-5' />
      </span>
      <p className='text-sm font-semibold text-gray-900'>{title}</p>
      <p className='mt-1 text-sm text-gray-500'>{description}</p>
      {action && <div className='mt-4'>{action}</div>}
    </section>
  );
}
